import { SectionNames } from '@/analytics/sectionNames';
import { performVWBasicButtonClick } from '@/analytics/events';
import { useTribalContext } from '@/context/tribal';
import useGlobalStore, {
  GlobalStoreStateConfiguration,
} from '@/stores/globalStore';
import { getActiveConfiguration } from '@/modules/utils/storeUtils';
import { BannerType, getBanner } from '@/modules/utils/banners';
import { Banner } from '@tribal-worldwide-london/ui-component-library-vwg';
import { EventBannerWrapper } from './EventBanner.styles';

function EventBanner() {
  const { analyticsManager, analyticsBuilder } = useTribalContext();
  const { retailers } = useGlobalStore((state) => state.app);
  const { app } = useGlobalStore();
  const activeConfiguration: GlobalStoreStateConfiguration | undefined =
    getActiveConfiguration(app);

  const fleetMode = activeConfiguration?.pdbData?.fleetMode || false;

  const banner = getBanner(
    fleetMode ? BannerType.EventFleet : BannerType.EventRetail
  );

  if (!banner) return;

  const onClickHandler = () => {
    window.open(banner.href, '_blank');
    performVWBasicButtonClick({
      label: banner.cta,
      sectionName: SectionNames.EVENT_BANNER,
      configuration: activeConfiguration,
      retailers,
      analyticsManager,
      analyticsBuilder,
    });
  };

  return (
    <EventBannerWrapper>
      <Banner
        title={banner.title}
        titleBold={banner.titleBold}
        copy={banner.copy}
        cta={{
          text: banner.cta,
          onClick: onClickHandler,
        }}
        image={banner.image}
        imageAlt={banner.imageAlt}
        termsAndConditions={banner.terms}
      />
    </EventBannerWrapper>
  );
}

export default EventBanner;
